/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, SAISON){
	const a = 'is-active';
	const v = 'is-visible';
	const $map = location.pathname;

	const greetingToggle = () => {
		$('.js-greeting-toggle').on('click', () => {
			$('.js-greeting-toggleBlock').slideToggle();
		});
	};

	// <代表メッセージ>
	if($map === '/company/greeting/' || $map === '/company/greeting/index.html') {
		greetingToggle();
	}


})(window.jQuery, window.SAISON);
